import { createContext, useContext } from 'react';

export type AIStudioEntryMethod =
  | 'conversation_drawer'
  | 'navbar_click'
  | 'sidebar_click'
  | 'slash_key'
  | 'toast_click';
export type AIStudioStartType =
  | 'flashback'
  | 'free_text'
  | 'most_common'
  | 'suggested';
export type AIStudioDisplayMode = 'fullscreen' | 'sidePanel';

export interface AIStudioOpenOptions {
  entryMethod?: AIStudioEntryMethod;
  prompt?: string;
  threadId?: string;
}

// Modal-consumed-at-open subset of AIStudioOpenOptions. `prompt` is omitted
// because it has a different consume timing (the chat sends it after mount,
// not the modal at open).
export interface AIStudioOpenContext {
  entryMethod?: AIStudioEntryMethod;
  threadId?: string;
}

// displayMode is the gated effective mode (see AIStudioProvider's
// ai_studio_sidebar_ux flag AND SUPER_ADMIN gate) — a stored sidePanel
// preference is suppressed to fullscreen unless both gates are on. The
// header's mode toggle shows only when the side panel is available.
export const AIStudioContext = createContext<{
  displayMode: AIStudioDisplayMode;
  isSidePanelAvailable: boolean;
  isLoading: boolean;
  isOpen: boolean;
  open: (options?: AIStudioOpenOptions) => void;
  setDisplayMode: (mode: AIStudioDisplayMode) => void;
}>({
  displayMode: 'fullscreen',
  isLoading: false,
  isOpen: false,
  isSidePanelAvailable: false,
  open: () => {},
  setDisplayMode: () => {},
});

export const useAIStudio = () => useContext(AIStudioContext);
